import { action, computed, makeObservable, observable } from "mobx";
import { DurationPurchase, NumberNull, UserShopOrder } from "../../interfaces";
import dayjs from "dayjs";
import { UserShopOrderGoodStore } from "./user-shop-order-good.store";

export class UserShopOrderStore implements UserShopOrder {
	@observable id = 0;
	@observable shop_good_id = 0;
	@observable shop_promo_code_id: NumberNull = null;
	@observable user_id = 0;
	@observable date_start = dayjs();
	@observable date_end = dayjs();
	@observable price = 0;
	@observable price_discount = 0;
	@observable recurrent = false;
	@observable type_payment_system = "";
	@observable status = "";
	@observable payload: unknown | null = null;
	@observable created_at = dayjs();
	@observable updated_at = dayjs();
	@observable grand_chart_ids: Array<number> = [];
	@observable shop_good: UserShopOrderGoodStore | null = null;

	constructor(initialData: UserShopOrder | null) {
		makeObservable(this);

		if (initialData) {
			this.fillStore(initialData);
		}
	}

	@action.bound
	hasGrandChart(grandChartId: number) {
		if (this.grand_chart_ids.includes(grandChartId)) {
			return true;
		}
		const includedGrandChartIds = this.shop_good?.included_grand_chart_ids || [];
		return includedGrandChartIds.includes(grandChartId);
	}

	@computed
	get isPaid() {
		return this.status === "paid";
	}

	@computed
	get isActive() {
		const today = dayjs();

		const isStarted = this.date_start.isBefore(today, "day") || this.date_start.isSame(today, "day");
		const isNotExpired = this.date_end.isAfter(today, "day") || this.date_end.isSame(today, "day");

		return this.isPaid && isStarted && isNotExpired;
	}

	@computed
	get duration(): DurationPurchase {
		if (this.shop_good?.shop_good_period_id === 2) {
			return DurationPurchase.Yearly;
		}
		return DurationPurchase.Monthly;
	}

	@action
	fillStore(data: UserShopOrder) {
		const {
			id,
			shop_good_id,
			shop_promo_code_id,
			user_id,
			date_start,
			date_end,
			price,
			price_discount,
			recurrent,
			type_payment_system,
			status,
			payload,
			created_at,
			updated_at,
			grand_chart_ids,
			shop_good,
		} = data;

		this.id = id;
		this.shop_good_id = shop_good_id;
		this.shop_promo_code_id = shop_promo_code_id;
		this.user_id = user_id;
		this.date_start = dayjs(date_start);
		this.date_end = dayjs(date_end);
		this.price = price;
		this.price_discount = price_discount;
		this.recurrent = recurrent;
		this.type_payment_system = type_payment_system;
		this.status = status;
		this.payload = payload ?? null;
		this.created_at = dayjs(created_at);
		this.updated_at = dayjs(updated_at);
		this.grand_chart_ids = grand_chart_ids;
		this.shop_good = shop_good ? new UserShopOrderGoodStore(shop_good) : null;
	}
}
